import { answeredMapper, calidadDatosMapper, invalidMapper, porcRespuestasMapper } from "../dashHelper"
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar, radialMapperByIndicator } from "../widgetsLibrary/widgetsLine"
import { commonWidgets, getCmID, jacCustomerJourneyMapper, getJacCustomerJourney, postVentaMapperJacCustomerJourney, getJacCalidadDatosWidget, getJacPorcRespuestasWidget } from "./commonWidgetsJac"

export default {
  title: "Demo Post postventa Dashboard",
  description: "Demo Post postventa Dashboard",
  backgroundClassName: (filters: any) => {
    return 'epsilon-hero-bg'
  },
  widgets: (filters: FiltersUI) => [
    getLineDetailedRadar({
      mainIndicator: 'Experiencia_CSI',
      radialIndicators: [
        'Experiencia_CSI',
        'Competencia_AS',
        'recepcion_CSI',
        'Avance_CSI',
        'entregapv',
        'Reparacion_CSI'
      ],
      radialType: 'byIndicator',
      size: [4, 3],
      title: 'widgets.snPostventa',
      criticalMomentInclude: [getCmID('Flotillas')],
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
        initialVisibleChart: 1,
        groups: ['JAC', 'Zona 1 P', 'Zona 2 P', 'Zona 3 P', 'Zona 4 P', 'Zona 5 P'],
        maxValue: 100
      },
      groupByLevel: 2,
      useNormalizedRadial: true,
      indicatorsNames: {
        'Experiencia_CSI': 'Mantenimiento',
        'Competencia_AS': 'Atención y amabilidad',
        'recepcion_CSI': 'Recepción',
        'Avance_CSI': 'Seguimiento',
        'entregapv': 'Entrega',
        'Reparacion_CSI': 'Retorno'
      },
      mainSort: { sortBy: 'group_1', value: 'asc' }
    }),
    //1
    {
      title: 'labels.surveys',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    {
      title: 'labels.alerts',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByMonth',
      subTitle: 'widgets.surveyCountMonth',
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      criticalMomentInclude: [getCmID('Flotillas')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByWeek',
      subTitle: 'widgets.surveyCountWeek',
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      criticalMomentInclude: [getCmID('Flotillas')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByMonth',
      subTitle: 'widgets.alertsCountMonth',
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      criticalMomentInclude: [getCmID('Flotillas')],
      extraConfigs: {
        useCurrent: 0,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByWeek',
      subTitle: 'widgets.alertsCountWeek',
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      criticalMomentInclude: [getCmID('Flotillas')],
      extraConfigs: {
        useCurrent: 0,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'widgets.npsPostventa',
      size: [2, 2],
      indicator: 'recomendacionpv',
    }),

    getJacCalidadDatosWidget(filters?.criticalMoments[0]),
    getJacPorcRespuestasWidget(filters?.criticalMoments[0]),
    /* getCommonWidget({
       commonWidgets: commonWidgets,
       name: 'multipleGaugeByQuestion',
       title: 'widgets.customerJourneyPostventa',
       mapper: jacCustomerJourneyMapper,
       indicator: 'MERGE',
       size: [4, 2],
       extraConfigs: {
         chartRadius: '80%',
         chartCenter: ['50%', '45%'],
         labelFontSize: 40,
         groupNameFormat: 'description',
         maxValue: 100,
       },
       extras: {
         indicators: 'POSTVENTA_CUSTOMER_JOURNEY,Avance_CSI,Reparacion_CSI',
       },
     }),
     */
    getJacCustomerJourney({
      id: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyPostventa',
      helpText: '',
      size: [4, 2],
      mapper: postVentaMapperJacCustomerJourney,
      criticalMomentInclude: [getCmID('Flotillas')],
      extraConfigs: {
        chartRadius: '80%',
        chartCenter: ['50%', '45%'],
        labelFontSize: 40,
        groupNameFormat: 'description',
        maxValue: 100,
        colors: undefined
      },
      indicators: [
        { name: 'Experiencia_CSI', formula: 'wavg-5' },
        { name: 'Competencia_AS', formula: 'wavg-5' },
        { name: 'recepcion_CSI', formula: 'wavg-5' },
        { name: 'Avance_CSI', formula: 'wavg-5' },
        { name: 'entregapv', formula: 'wavg-5' },
        { name: 'Reparacion_CSI', formula: 'wavg-5' },
      ],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestRotativasPostventa',
      size: [2, 1],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [getCmID('Flotillas')],
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstRotativasPostventa',
      size: [2, 1],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [getCmID('Flotillas')],
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'mapByGeos',
      title: 'Mapa de estaciones',
      size: [2, 2],
      indicator: 'recomendacionpv',
      criticalMomentInclude: [getCmID('Flotillas')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsPostventa',
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76'
      },
      indicator: 'recomendacionpv',
      criticalMomentInclude: [getCmID('Flotillas')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsPostventa',
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476'
      },
      indicator: 'recomendacionpv',
      criticalMomentInclude: [getCmID('Flotillas')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'widgets.wordCount',
      size: [4, 2],
      criticalMomentInclude: [getCmID('Flotillas')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'widgets.ishikawa',
      size: [4, 2],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [getCmID('Flotillas')],
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: "widgets.sentimentAnalysis",
      size: [4, 3],
      indicator: 'SENTIMENT',
      criticalMomentInclude: [getCmID('Flotillas')],
    })
  ],
} as DasboardConfig
